import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from "ngx-toastr";
import { environment } from '../../../environments/environment';
import { CompanyService } from '../../services/company.service';
import { AuthenticationService } from '../authentication.service';

@Component({
  selector: 'app-companyregistration',
  templateUrl: './companyregistration.component.html',
  styleUrls: ['./companyregistration.component.scss']
})
export class CompanyregistrationComponent implements OnInit {

  mode = true;
  captcha: any;

  constructor(
    private _toaster: ToastrService,
    private _companyservice: CompanyService,
    private authService: AuthenticationService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
  ) { }
  siteKey;
  registerSuccess = false;
  ngOnInit() {
    this.siteKey = environment.captchaSiteKey;
    this.IntializeRegisterForm();
  }

  registerForm: UntypedFormGroup;
  submitted = false;

  IntializeRegisterForm() {

    this.registerForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.minLength(8), Validators.required]],
      confirmPassword: ['', Validators.required],
      name: ['', Validators.required],
      mc: ['', [Validators.required, Validators.maxLength(7), Validators.minLength(5)]],
      companyType: ['Freight_Haul', Validators.required],
      address: ['', Validators.required],
      subscriptionType: ['advance', Validators.required],
      captchatoken: ['', Validators.required],

    }, { validator: this.customValidations() });

  }


  customValidations() {
    return (formGroup: UntypedFormGroup) => {
      const control = formGroup.controls["password"];
      const matchingControl = formGroup.controls["confirmPassword"];

      if (matchingControl.errors && !matchingControl.errors["mustMatch"]) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    }
  }

  public errorHandling = (control: string, error: string) => {
    if (error != '') {
      return this.registerForm.controls[control].hasError(error);
    }
    else {
      return this.registerForm.controls[control].invalid;
    }
  }

  public isControlModified = (control: string) => {
    if (this.submitClicked || this.registerForm.controls[control].touched || !this.registerForm.controls[control].pristine) {

      return true;
    }
    else { return false };
  }

  get f() { return this.registerForm.controls; }

  Goback() {
    this.router.navigateByUrl("/login");
  }
  googleAddress;
  showGoogleAddress = "";
  getGoogleAddress($event) {
    this.googleAddress = $event
    this.registerForm.get("address").setValue(this.googleAddress);
    // console.log(this.googleAddress);
  }
  getIsValidAddress($event) {
    if (!$event) {
      this.registerForm.get("address").setValue('');
    }
    else {
      this.registerForm.get("address").setValue(this.googleAddress);
    }
    // console.log(this.googleAddress);
  }
  submitClicked = false;
  tempConfirmPassword;
  submit() {
    this.submitClicked = true;
    // console.log(this.registerForm);
    // console.log(this.registerForm.value);

    if (this.registerForm.valid) {
      delete this.registerForm.value.confirmPassword;
      // console.log(this.registerForm.value);
      this._companyservice.newCompanyregister(this.registerForm.value).subscribe(
        (response) => {
          // console.log(response);
          if (response.Status != "error") {
            this._toaster.info(response.message, "Success", { timeOut: 1000 });
            this.registerSuccess = true;
            //this.router.navigateByUrl("/login");
          } else {
            this.registerSuccess = false;
            this.submitClicked=false;
            this._toaster.error(response.error, "Failed", { timeOut: 1000 });
          }
        },
        (error) => {
          this.registerSuccess = false;
          this.submitClicked=false;
          this._toaster.error(error.error, error.json().error.message || "Failed", { timeOut: 1000 });
        }
      );
    }
    else {
      this.submitClicked=false;
      this._toaster.error("Please fix the validations", "Failed", {
        timeOut: 1000,
      });
    }
  }

  resolved(captchaResponse: string, res) {
    // console.log(`Resolved response token: ${captchaResponse}`);

    this.captcha = captchaResponse;
    this.registerForm.get("captchatoken").setValue(this.captcha);
  }
  reset() {
    this.IntializeRegisterForm();
  }
}
